export default "__VITE_ASSET__a9fab825__"